

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import WidgetTools from "../widgetTools";
import { removeWidget } from "src/redux/supervisorSlice";
import MonitorWSService from 'src/services/monitorwsservice';
import PortCard from './portcard';

function PortsStatus(props) {
    const { t } = useTranslation();
    const [ports, setPorts] = useState([]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/portsstatus", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("portsstatus");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {
            MonitorWSService.stompClient.send("/app/subscribe/portsstatus", {}, JSON.stringify({
                token: props.token
            }));
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/portsstatus/`, updateState, { id: "portsstatus" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const updateState = (groups) => {
        if (!document.hidden) {
            let data = JSON.parse(groups.body);
            setPorts(data);
        }
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="portsstatuswidget">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("bell-on")} /> {t("portsstatus")} <span className="badge badge-light-primary fs-base">{ports.length}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={null}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px", overflow: "auto" }}>
                <div className="agents-panel-list">
                    {
                        ports.map(v => {
                            let ret = <></>
                            if (!v.ext.toLowerCase().startsWith("w"))
                                ret = <PortCard key={v.ext} port={v}></PortCard>
                            return ret;
                        })
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        connected: state.parameters.connected
    };
};

export default connect(mapStateToProps, { removeWidget })(PortsStatus);